const jobTypes = {
  LONG: 'long',
  DAY: 'day',
  BOTH: 'both',
};

module.exports = jobTypes;
